import { useSelector } from 'react-redux';

export default function intextBoxes() {
  const isDoi = useSelector((state) => state.view) === 'doi';

  const toggleVisivilityOfBoxes = () => {
    const allBoxes = document.querySelectorAll('.react-newsletter-intext-box');

    allBoxes.forEach( box => isDoi ? box.classList.add('hidden') : box.classList.remove('hidden') )
  }

  toggleVisivilityOfBoxes();

  return null;
}
